import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { 
  Shield, LayoutDashboard, ShieldAlert, ScrollText, Users, 
  LogOut, UserPlus, Activity, Server, Wifi, RefreshCw, X, User, Mail, Lock, Settings, Trash2, Edit2, Building2, CreditCard, BrainCircuit, CheckCircle     
} from 'lucide-react';
import SubscriptionGuard from './SubscriptionGuard'; 
import logo from '../img/image-2026-05-21-08-52-40-636.png';

const UsersPage = ({ onLogout }) => {
  const [users, setUsers] = useState([]);
  const [tenants, setTenants] = useState([]); 
  const [data, setData] = useState({subscription_status: 'loading', agents_online: 0, uptime: '...' });
  const [loading, setLoading] = useState(false);

  const [showModal, setShowModal] = useState(false); 
  const [showTenantModal, setShowTenantModal] = useState(false); 
  const [newTenantName, setNewTenantName] = useState('');
  
  const [isEditing, setIsEditing] = useState(false); 
  const [editingUserId, setEditingUserId] = useState(null);
  const [companyName, setCompanyName] = useState('');
  
  const navigate = useNavigate();
  const userRole = localStorage.getItem('role');
  const currentUser = localStorage.getItem('user');
  const tenantId = localStorage.getItem('tenant_id');

  const [formData, setFormData] = useState({ 
    username: '', 
    email: '', 
    password: '', 
    role: 'Viewer', 
    tenant_id: tenantId 
  });

  const refreshData = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const config = { headers: { 'X-NOC-Token': token } };
      
   
      const apiCalls = [
        axios.get('https://ai-noc.skynix.co/api/users', config),
        axios.get('https://ai-noc.skynix.co/api/stats', config),
        axios.get('https://ai-noc.skynix.co/api/tenant/info', config)
      ];

     
      if (String(tenantId) === '1') {
        apiCalls.push(axios.get('https://ai-noc.skynix.co/api/tenants', config));
      }
      
      const responses = await Promise.all(apiCalls);
      
      setUsers(responses[0].data || []);
      setData(responses[1].data);
      setCompanyName(responses[2].data.name)
      
      
      if (String(tenantId) === '1' && responses[2]) {
        setTenants(responses[3].data || []);
      } else {
        setTenants([]); 
      }

    } catch (e) { 
      if (e.response?.status === 401) onLogout(); 
      console.error("Fetch error:", e);
    }
    setLoading(false);
  };

  useEffect(() => { refreshData(); }, []);

  const handleCreateTenant = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem('token');
      await axios.post('https://ai-noc.skynix.co/api/tenants', { name: newTenantName }, { headers: { 'X-NOC-Token': token } });
      setNewTenantName('');
      setShowTenantModal(false);
      refreshData();
    } catch (err) { alert("Error creating company"); }
  };

  const openEditModal = (user) => {
    setIsEditing(true);
    setEditingUserId(user.id);
    setFormData({ 
      username: user.username, 
      email: user.email, 
      password: '', 
      role: user.role,
      tenant_id: String(user.tenant_id) 
    });
    setShowModal(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); 
    try {
      const token = localStorage.getItem('token');
      const config = { headers: { 'X-NOC-Token': token } };
      const finalData = {
        ...formData,
        tenant_id: Number(String(tenantId) === '1' ? formData.tenant_id : tenantId)
      };

      if (isEditing) {
        await axios.post(`https://ai-noc.skynix.co/api/users/${editingUserId}/update`, finalData, config);
      } else {
        await axios.post('https://ai-noc.skynix.co/api/users', finalData, config);
      }
      
      setShowModal(false);
      refreshData();
    } catch (err) { 
      const msg = err.response?.data?.detail || "Connection error";
      alert("Failed to save user: " + msg); 
    } finally {
      setLoading(false);
    }
};
  const handleDelete = async (id, name) => {
    if (name === currentUser) return alert("Cannot delete self.");
    if (window.confirm(`Delete user ${name}?`)) {
      try {
        await axios.delete(`https://ai-noc.skynix.co/api/users/${id}`, { headers: { 'X-NOC-Token': localStorage.getItem('token') } });
        refreshData();
      } catch (e) { alert("Delete failed."); }
    }
  };

  return (
    <div className="d-flex" style={{ minHeight: '100vh', backgroundColor: '#0b0e14', color: '#e2e8f0' }}>
      <SubscriptionGuard data={data} onLogout={onLogout} tenantId={tenantId}>
      
      <div className="sidebar" style={{ width: '64px', background: '#0d1117', borderRight: '1px solid #1e293b', height: '100vh', position: 'fixed', display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '25px 0', zIndex: 1050 }}>
              <div
                        className="sidebar-item d-flex justify-content-center"
                        data-label="Go to Landing Page" 
                        onClick={() => window.location.href = 'https://noc.skynix.co'}
                        style={{
                          transform: 'translateY(-6px)',
                          marginBottom: '20px',
                          cursor: 'pointer' 
                        }}
                      >
                        <img
                          src={logo}
                          alt="SKYNIX"
                          style={{
                            width: '34px',
                            height: '34px',
                            objectFit: 'contain'
                          }}
                        />
                      </div>
        <div className="sidebar-item" data-label="Dashboard" onClick={() => navigate('/')} style={{color:'#94a3b8', cursor:'pointer', marginBottom:'30px'}}><LayoutDashboard size={24} /></div>
        <div className="sidebar-item" data-label="Security Incidents" onClick={() => navigate('/incidents')} style={{color:'#94a3b8', cursor:'pointer', marginBottom:'30px'}}><ShieldAlert size={24} /></div>
        <div className="sidebar-item" data-label="System Logs" onClick={() => navigate('/logs')} style={{ color: '#94a3b8', cursor: 'pointer', marginBottom: '30px' }}><ScrollText size={24} /></div>
        <div className="sidebar-item" data-label="Infrastructure" onClick={() => navigate('/infrastructure')} style={{ color: '#94a3b8', cursor: 'pointer', marginBottom: '30px' }}><Server size={24} /></div>
        <div className="sidebar-item active" data-label="User Management" style={{ background: 'rgba(0, 242, 255, 0.1)', color: '#00f2ff', padding: '10px', borderRadius: '8px', marginBottom: '30px' }}><Users size={24} /></div>
        <div className="sidebar-item" data-label="Billing & Plans" onClick={() => navigate('/subscription')} style={{ color: '#94a3b8', cursor: 'pointer', marginBottom: '30px' }}><CreditCard size={24} /></div>
        <div className="sidebar-item mt-auto mb-3"  data-label="Settings" onClick={() => navigate('/settings')} style={{color:'#94a3b8', cursor:'pointer', marginBottom:'20px'}}><Settings size={24} /></div>
        <div className="sidebar-item mb-3"  data-label="Logout" onClick={onLogout} style={{cursor: 'pointer'}}><LogOut size={24} className="text-danger" /></div>
      </div>

      <div className="main-wrapper" style={{ marginLeft: '64px', width: 'calc(100% - 64px)' }}>
                   
                   
                   <header className="soc-header" style={{ height: '60px', borderBottom: '1px solid #1e293b', display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 24px', background: '#0b0e14' }}>
                     <div className="d-flex align-items-center gap-3">
                 
                      <h5 
                        className="sidebar-item tooltip-bottom m-0 d-flex align-items-center"
                        data-label="Go to Landing Page"
                        onClick={() => window.location.href = 'https://noc.skynix.co'}
                        style={{ 
                          color: '#00f2ff', 
                          fontSize: '1.1rem', 
                          cursor: 'pointer',
                          lineHeight: '1',      
                          transform: 'translateY(1px)' 
                        }}
                      >
                        SKYNIX <span className="text-white ms-2">AI-NOC</span>
                      </h5>
                       <div style={{ width: '1px', height: '24px', background: '#334155' }}></div>
                       <div className="text-secondary small d-flex align-items-center gap-2" style={{ fontSize: '0.9rem', fontWeight: '500', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                         <Activity size={16} className="text-info" /> Security Operations Center
                       </div>
                     </div>
                     
                     <div className="d-flex gap-4 align-items-center">
                      <div style={{ 
                                                     background: data.subscription_status === 'active' 
                                                       ? 'rgba(0, 242, 255, 0.1)' 
                                                       : data.subscription_status === 'loading' 
                                                         ? 'rgba(148, 163, 184, 0.1)' 
                                                         : 'rgba(239, 68, 68, 0.1)',  
                                                     
                                                     color: data.subscription_status === 'active' 
                                                       ? '#00f2ff' 
                                                       : data.subscription_status === 'loading' 
                                                         ? '#94a3b8' 
                                                         : '#ef4444', 
                                                     
                                                     padding: '4px 14px', 
                                                     borderRadius: '20px', 
                                                     fontSize: '0.8rem', 
                                                     border: `1px solid ${
                                                       data.subscription_status === 'active' 
                                                         ? '#00f2ff44' 
                                                         : data.subscription_status === 'loading' 
                                                           ? '#94a3b844' 
                                                           : '#ef444444'
                                                     }`, 
                                                     fontWeight: '600' 
                                                   }}>
                                                     {data.subscription_status === 'loading' 
                                                       ? 'Verifying license...' 
                                                       : data.subscription_status === 'active'
                                                         ? `Plan: ${data.plan_name} (${data.agents_online}/${data.max_servers})`
                                                         : 'SUBSCRIPTION INACTIVE'
                                                     }
                                                   </div>
                                                   <div className="header-metric small text-secondary">
                                                 <BrainCircuit size={14} className="me-1" style={{ color: '#a855f7' }}/> AI Tokens: <b className={data.ai_tokens_spent >= data.ai_tokens_limit ? "text-danger" : "text-white"}>
                                                     {data.ai_tokens_spent?.toLocaleString() || 0} / {data.ai_tokens_limit?.toLocaleString() || '1,000,000'}
                                                 </b>
                                               </div>
                       <div style={{ background: 'rgba(16,185,129,0.1)', color: '#10b981', padding: '4px 14px', borderRadius: '20px', fontSize: '0.8rem', border: '1px solid #10b98144', fontWeight: '600' }}>
                          Core: Healthy
                       </div>
                       <div className="header-metric small text-secondary">
                          <Server size={14} className="me-1" style={{ color: '#00f2ff' }}/> Agents Online: <b className="text-white">{data.agents_online}</b>
                       </div>
                       <div className="header-metric small text-secondary">
                          <Wifi size={14} className="me-1" style={{ color: '#00f2ff' }}/> Uptime: <b className="text-white" style={{ color: '#00f2ff' }}>{data.uptime}</b>
                       </div>
                     </div>
                   </header>

        <div className="p-4">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div><h2 className="fw-bold m-0">System Users</h2><p className="text-secondary small m-0">Provision access for your team</p></div>
            
            {userRole === 'Administrator' && (
              <div className="d-flex gap-2">
                {String(tenantId) === '1' && (
                  <button onClick={() => setShowTenantModal(true)} className="btn btn-outline-info btn-sm fw-bold px-4 d-flex align-items-center gap-2">
                    <Building2 size={16} /> Add Company
                  </button>
                )}
                <button 
                  onClick={() => { setIsEditing(false); setFormData({username:'',email:'',password:'',role:'Viewer', tenant_id: tenantId}); setShowModal(true); }} 
                  className="btn btn-info btn-sm fw-bold px-4 shadow-info d-flex align-items-center gap-2"
                >
                  <UserPlus size={18} /> New User
                </button>
              </div>
            )}
          </div>

          <div className="d-flex flex-column gap-2">
            {users.map(u => (
              <div key={u.id} className="noc-card p-3 d-flex align-items-center shadow-sm" style={{ background: '#151921', border: '1px solid #1e293b', borderRadius: '12px' }}>
                <div className="rounded-circle d-flex align-items-center justify-content-center fw-bold text-white me-4" style={{ width: '42px', height: '42px', backgroundColor: '#334155' }}>
                  {u.username.slice(0,2).toUpperCase()}
                </div>
                <div style={{ width: '320px' }}>
                    <div className="d-flex align-items-center gap-2">
                        <h6 className="m-0 fw-bold text-white">{u.username}</h6>
                        {u.username === currentUser && String(u.tenant_id) === String(tenantId) && (
                          <span className="badge bg-info text-dark px-1" style={{fontSize:'8px', fontWeight:'800'}}>YOU</span>
                      )}
                    </div>
                    <div className="text-secondary small">{u.email}</div>
                </div>
                <div style={{ width: '220px' }}>
                   <div className="text-secondary x-small uppercase fw-bold" style={{fontSize:'9px'}}>Tenant / Company</div>
                   <div className="text-info small">{u.tenant_name}</div>
                </div>
                <div style={{ width: '180px' }}>
                   <div className="text-secondary x-small uppercase fw-bold" style={{fontSize:'9px'}}>Access Role</div>
                   <div className="text-white small">{u.role}</div>
                </div>
                <div style={{ width: '180px' }}>
                <div className="text-secondary x-small uppercase fw-bold" style={{fontSize:'9px'}}>Account Status</div>
                {!u.last_login ? (
                 
                  <div className="d-flex align-items-center gap-2 text-warning animate-pulse">
                      <Mail size={14} className="text-warning" />
                      <span style={{ fontSize: '11px', fontWeight: '700' }}>Invitation Sent</span>
                  </div>
                ) : (
                  
                  <div className="d-flex align-items-center gap-2 text-success opacity-70">
                      <CheckCircle size={14} />
                      <span style={{ fontSize: '11px' }}>Active Account</span>
                  </div>
                )}
              </div>
               <div className="ms-auto d-flex gap-2">
                   {userRole === 'Administrator' ? (
                     <>
                        <button onClick={() => openEditModal(u)} className="btn btn-link text-info p-1"><Edit2 size={18} /></button>
                        {u.username !== currentUser && (
                          <button onClick={() => handleDelete(u.id, u.username)} className="btn btn-link text-secondary p-1 hover-red">
                            <Trash2 size={18} />
                          </button>
                        )}
                     </>
                   ) : (
                      <span className="text-info px-3 italic fw-bold" style={{ fontSize: '10px', opacity: 0.8 }}>
                        READ ONLY
                      </span>
                   )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {showModal && (
        <div className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center" style={{ zIndex: 2000, background: 'rgba(0,0,0,0.85)' }}>
          <div className="noc-card p-4 border-secondary shadow-lg" style={{ width: '420px', background: '#0d1117', borderRadius: '12px', border: '1px solid #1e293b' }}>
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h5 className="m-0 fw-bold text-info">{isEditing ? 'Modify Account' : 'New System User'}</h5>
              <X size={24} className="text-secondary cursor-pointer" onClick={() => setShowModal(false)} />
            </div>
            <form onSubmit={handleSubmit}>
              {String(tenantId) === '1' ? (
                <div className="mb-3">
                  <label className="text-secondary small uppercase fw-bold">Company</label>
                  <select className="form-select bg-dark border-secondary text-white shadow-none" 
                          value={formData.tenant_id}
                          onChange={e => setFormData({...formData, tenant_id: e.target.value})}>
                    {tenants.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
                  </select>
                </div>
              ) : (
                <div className="mb-3">
                  <label className="text-secondary small uppercase fw-bold">Company</label>
                  <div className="p-2 bg-dark rounded border border-secondary text-info small fw-bold d-flex align-items-center gap-2">
                     <Building2 size={14} /> {companyName || 'Your Account'}
                  </div>
                </div>
              )}
              <div className="mb-3">
                <label className="text-secondary small uppercase fw-bold">Username</label>
                <input type="text" className="form-control bg-dark border-secondary text-white" value={formData.username} onChange={e => setFormData({...formData, username: e.target.value})} required />
              </div>
              <div className="mb-3">
                <label className="text-secondary small uppercase fw-bold">Corporate Email</label>
                <input type="email" className="form-control bg-dark border-secondary text-white" value={formData.email} onChange={e => setFormData({...formData, email: e.target.value})} required />
              </div>
              {!isEditing && (
                <div className="mb-3">
                  <label className="text-secondary small uppercase fw-bold">Initial Password</label>
                  <input type="password" placeholder="••••••••" className="form-control bg-dark border-secondary text-white" onChange={e => setFormData({...formData, password: e.target.value})} required />
                </div>
              )}
              <div className="mb-4">
                <label className="text-info small fw-bold uppercase">Authorization Level</label>
                <select className="form-select bg-dark border-info text-white shadow-none" value={formData.role} onChange={e => setFormData({...formData, role: e.target.value})}>
                  <option value="Viewer">Viewer</option>
                  <option value="Administrator">Administrator</option>
                </select>
              </div>
              <button type="submit" className="btn btn-info w-100 fw-bold py-2 text-uppercase">{isEditing ? 'Apply Changes' : 'Provision Account'}</button>
            </form>
          </div>
        </div>
      )}

      {showTenantModal && (
        <div className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center" style={{ zIndex: 2005, background: 'rgba(0,0,0,0.9)' }}>
          <div className="noc-card p-4 border-info shadow-lg" style={{ width: '400px', background: '#0d1117', borderRadius: '12px', border: '1px solid #00f2ff' }}>
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h5 className="m-0 fw-bold text-info">Register New Company</h5>
              <X size={24} className="text-secondary cursor-pointer" onClick={() => setShowTenantModal(false)} />
            </div>
            <form onSubmit={handleCreateTenant}>
              <div className="mb-4">
                <label className="text-secondary small uppercase fw-bold">Company Name</label>
                <input type="text" className="form-control bg-black border-secondary text-white fw-bold" placeholder="e.g. Acme Corp Security"
                  value={newTenantName} onChange={e => setNewTenantName(e.target.value)} required />
              </div>
              <button type="submit" className="btn btn-info w-100 fw-bold py-2">CREATE TENANT</button>
            </form>
          </div>
        </div>
      )}
      </SubscriptionGuard>
    </div>
  );
};

export default UsersPage;